/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AvailabilityDto,
  BooleanDto,
  FcbUserGridDtoPaginatedResults,
  FilterCriteriaInfo,
  MetierLocaliteDto,
  SelectItem,
  UserActionDto,
  UserAvailabilityDto,
  UserDto,
  UserEditProfileDto,
  UserMetierDto,
  UserSearch,
  ValidationError,
} from '../models/index';
import {
    AvailabilityDtoFromJSON,
    AvailabilityDtoToJSON,
    BooleanDtoFromJSON,
    BooleanDtoToJSON,
    FcbUserGridDtoPaginatedResultsFromJSON,
    FcbUserGridDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    MetierLocaliteDtoFromJSON,
    MetierLocaliteDtoToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
    UserActionDtoFromJSON,
    UserActionDtoToJSON,
    UserAvailabilityDtoFromJSON,
    UserAvailabilityDtoToJSON,
    UserDtoFromJSON,
    UserDtoToJSON,
    UserEditProfileDtoFromJSON,
    UserEditProfileDtoToJSON,
    UserMetierDtoFromJSON,
    UserMetierDtoToJSON,
    UserSearchFromJSON,
    UserSearchToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models/index';

export interface UtilisateurAvailabilityRequest {
    iduser: number;
    body?: Date;
}

export interface UtilisateurBaseSearchRequest {
    UserSearch?: UserSearch;
}

export interface UtilisateurDeleteRequest {
    id?: number;
}

export interface UtilisateurGetDisplayNameRequest {
    id?: number;
}

export interface UtilisateurGetEditProfileRequest {
    idUser?: number;
}

export interface UtilisateurGetMetierLocalitesRequest {
    id: number;
    idmetier: number;
}

export interface UtilisateurGetMetiersRequest {
    id: number;
}

export interface UtilisateurGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface UtilisateurGetSelectItemsRequest {
    searchField: string;
}

export interface UtilisateurGetUserRequest {
    idUser?: number;
}

export interface UtilisateurIsCalcRequest {
    iduser?: number;
}

export interface UtilisateurIsHopeRequest {
    iduser?: number;
}

export interface UtilisateurLoginExistsRequest {
    login?: string;
}

export interface UtilisateurSaveRequest {
    UserDto?: UserDto;
}

export interface UtilisateurSaveAvailabilityRequest {
    UserAvailabilityDto?: UserAvailabilityDto;
}

export interface UtilisateurSaveEditProfileRequest {
    UserEditProfileDto?: UserEditProfileDto;
}

export interface UtilisateurSaveUserMetierRequest {
    id: number;
    UserMetierDto?: UserMetierDto;
}

export interface UtilisateurSaveUserMetierLocaliteRequest {
    id: number;
    idmetier: number;
    MetierLocaliteDto?: MetierLocaliteDto;
}

/**
 * 
 */
export class UtilisateurApi extends runtime.BaseAPI {

    /**
     */
    async utilisateurAvailabilityRaw(requestParameters: UtilisateurAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserAvailabilityDto>>> {
        if (requestParameters.iduser === null || requestParameters.iduser === undefined) {
            throw new runtime.RequiredError('iduser','Required parameter requestParameters.iduser was null or undefined when calling utilisateurAvailability.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/{iduser}/availability`.replace(`{${"iduser"}}`, encodeURIComponent(String(requestParameters.iduser))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserAvailabilityDtoFromJSON));
    }

    /**
     */
    async utilisateurAvailability(requestParameters: UtilisateurAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserAvailabilityDto>> {
        const response = await this.utilisateurAvailabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurBaseSearchRaw(requestParameters: UtilisateurBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbUserGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserSearchToJSON(requestParameters.UserSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbUserGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurBaseSearch(requestParameters: UtilisateurBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbUserGridDtoPaginatedResults> {
        const response = await this.utilisateurBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurDefaultAvailabilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AvailabilityDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/default-availability`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AvailabilityDtoFromJSON));
    }

    /**
     */
    async utilisateurDefaultAvailability(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AvailabilityDto>> {
        const response = await this.utilisateurDefaultAvailabilityRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurDeleteRaw(requestParameters: UtilisateurDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async utilisateurDelete(requestParameters: UtilisateurDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.utilisateurDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async utilisateurGetDisplayNameRaw(requestParameters: UtilisateurGetDisplayNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/displayName`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async utilisateurGetDisplayName(requestParameters: UtilisateurGetDisplayNameRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.utilisateurGetDisplayNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurGetEditProfileRaw(requestParameters: UtilisateurGetEditProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserEditProfileDto>> {
        const queryParameters: any = {};

        if (requestParameters.idUser !== undefined) {
            queryParameters['idUser'] = requestParameters.idUser;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/editProfile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserEditProfileDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurGetEditProfile(requestParameters: UtilisateurGetEditProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserEditProfileDto> {
        const response = await this.utilisateurGetEditProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurGetMetierLocalitesRaw(requestParameters: UtilisateurGetMetierLocalitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MetierLocaliteDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling utilisateurGetMetierLocalites.');
        }

        if (requestParameters.idmetier === null || requestParameters.idmetier === undefined) {
            throw new runtime.RequiredError('idmetier','Required parameter requestParameters.idmetier was null or undefined when calling utilisateurGetMetierLocalites.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/{id}/metiers/{idmetier}/localites`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"idmetier"}}`, encodeURIComponent(String(requestParameters.idmetier))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MetierLocaliteDtoFromJSON));
    }

    /**
     */
    async utilisateurGetMetierLocalites(requestParameters: UtilisateurGetMetierLocalitesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MetierLocaliteDto>> {
        const response = await this.utilisateurGetMetierLocalitesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurGetMetiersRaw(requestParameters: UtilisateurGetMetiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserMetierDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling utilisateurGetMetiers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/{id}/metiers`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserMetierDtoFromJSON));
    }

    /**
     */
    async utilisateurGetMetiers(requestParameters: UtilisateurGetMetiersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserMetierDto>> {
        const response = await this.utilisateurGetMetiersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurGetSearchCriteriasRaw(requestParameters: UtilisateurGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async utilisateurGetSearchCriterias(requestParameters: UtilisateurGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.utilisateurGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurGetSelectItemsRaw(requestParameters: UtilisateurGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling utilisateurGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async utilisateurGetSelectItems(requestParameters: UtilisateurGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.utilisateurGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurGetUserRaw(requestParameters: UtilisateurGetUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDto>> {
        const queryParameters: any = {};

        if (requestParameters.idUser !== undefined) {
            queryParameters['idUser'] = requestParameters.idUser;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurGetUser(requestParameters: UtilisateurGetUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDto> {
        const response = await this.utilisateurGetUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurGetUserProfileActionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserActionDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/GetUserProfileActions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserActionDtoFromJSON));
    }

    /**
     */
    async utilisateurGetUserProfileActions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserActionDto>> {
        const response = await this.utilisateurGetUserProfileActionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurGetUserValidationDirectionRightRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BooleanDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/validationDirection`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BooleanDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurGetUserValidationDirectionRight(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BooleanDto> {
        const response = await this.utilisateurGetUserValidationDirectionRightRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurIsCalcRaw(requestParameters: UtilisateurIsCalcRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BooleanDto>> {
        const queryParameters: any = {};

        if (requestParameters.iduser !== undefined) {
            queryParameters['iduser'] = requestParameters.iduser;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/isCalc`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BooleanDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurIsCalc(requestParameters: UtilisateurIsCalcRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BooleanDto> {
        const response = await this.utilisateurIsCalcRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurIsHopeRaw(requestParameters: UtilisateurIsHopeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BooleanDto>> {
        const queryParameters: any = {};

        if (requestParameters.iduser !== undefined) {
            queryParameters['iduser'] = requestParameters.iduser;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/isHope`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BooleanDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurIsHope(requestParameters: UtilisateurIsHopeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BooleanDto> {
        const response = await this.utilisateurIsHopeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurLoginExistsRaw(requestParameters: UtilisateurLoginExistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidationError>> {
        const queryParameters: any = {};

        if (requestParameters.login !== undefined) {
            queryParameters['login'] = requestParameters.login;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/loginExists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidationErrorFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurLoginExists(requestParameters: UtilisateurLoginExistsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidationError> {
        const response = await this.utilisateurLoginExistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurSaveRaw(requestParameters: UtilisateurSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserDtoToJSON(requestParameters.UserDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurSave(requestParameters: UtilisateurSaveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserDto> {
        const response = await this.utilisateurSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurSaveAvailabilityRaw(requestParameters: UtilisateurSaveAvailabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/save-availability`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserAvailabilityDtoToJSON(requestParameters.UserAvailabilityDto),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async utilisateurSaveAvailability(requestParameters: UtilisateurSaveAvailabilityRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.utilisateurSaveAvailabilityRaw(requestParameters, initOverrides);
    }

    /**
     */
    async utilisateurSaveEditProfileRaw(requestParameters: UtilisateurSaveEditProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserEditProfileDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/saveEditProfile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserEditProfileDtoToJSON(requestParameters.UserEditProfileDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserEditProfileDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurSaveEditProfile(requestParameters: UtilisateurSaveEditProfileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserEditProfileDto> {
        const response = await this.utilisateurSaveEditProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurSaveUserMetierRaw(requestParameters: UtilisateurSaveUserMetierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserMetierDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling utilisateurSaveUserMetier.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/{id}/metier`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserMetierDtoToJSON(requestParameters.UserMetierDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserMetierDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurSaveUserMetier(requestParameters: UtilisateurSaveUserMetierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserMetierDto> {
        const response = await this.utilisateurSaveUserMetierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async utilisateurSaveUserMetierLocaliteRaw(requestParameters: UtilisateurSaveUserMetierLocaliteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MetierLocaliteDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling utilisateurSaveUserMetierLocalite.');
        }

        if (requestParameters.idmetier === null || requestParameters.idmetier === undefined) {
            throw new runtime.RequiredError('idmetier','Required parameter requestParameters.idmetier was null or undefined when calling utilisateurSaveUserMetierLocalite.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/Utilisateur/{id}/metiers/{idmetier}/localite`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"idmetier"}}`, encodeURIComponent(String(requestParameters.idmetier))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MetierLocaliteDtoToJSON(requestParameters.MetierLocaliteDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MetierLocaliteDtoFromJSON(jsonValue));
    }

    /**
     */
    async utilisateurSaveUserMetierLocalite(requestParameters: UtilisateurSaveUserMetierLocaliteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MetierLocaliteDto> {
        const response = await this.utilisateurSaveUserMetierLocaliteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
